export function setCssVariable(name: string, value: string): void {
  document.documentElement.style.setProperty(name, value);
}
